import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=3b51fc5c&scoped=true&"
import script from "./ProductListItem.ts?vue&type=script&lang=ts&"
export * from "./ProductListItem.ts?vue&type=script&lang=ts&"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=3b51fc5c&scoped=true&lang=css&"
import style1 from "./ProductListItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51fc5c",
  null
  
)

export default component.exports